<template>
  <div class="add-hemorrhage">
    <div class="breadcrumb" v-if="$route.path === '/addhemorrhage'">添加出血类型</div>
    <div class="third-title" v-if="$route.path === '/addhemorrhage'"><span>出血信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="hemorrhageInfo" hide- label-width="100px" :rules="rules" ref="formRef">
        <el-form-item label="出血类型:" prop="bleedName">
          <el-input v-model="hemorrhageInfo.bleedName" ref="inputRef" maxlength="20" placeholder="长度不超过20" clearable></el-input>
        </el-form-item>
        <el-form-item label="出血:">
          <div style="display: flex;width: 500px;flex-wrap: wrap;">
            <div class="spec-mm">
              <el-form-item label-width="0" label="" style="margin:0;" prop="bleedTop">
                <el-input placeholder="" v-model="hemorrhageInfo.bleedTop" style="width:200px;">
                  <template slot="prepend">上方</template>
                  <template slot="append">mm</template>
                </el-input>
              </el-form-item>
            </div>
            <div class="spec-mm">
              <el-form-item label-width="0" label="" style="margin:0;" prop="bleedBottom">
                <el-input placeholder="" v-model="hemorrhageInfo.bleedBottom" style="width:200px;">
                  <template slot="prepend">下方</template>
                  <template slot="append">mm</template>
                </el-input>
              </el-form-item>
            </div>
            <div class="spec-mm" style="float:none;">
              <el-form-item label-width="0" label="" style="margin:0;" prop="bleedLeft">
                <el-input placeholder="" v-model="hemorrhageInfo.bleedLeft" style="width:200px;">
                  <template slot="prepend">左侧</template>
                  <template slot="append">mm</template>
                </el-input>
              </el-form-item>
            </div>
            <div class="spec-mm">
              <el-form-item label-width="0" label="" style="margin:0;" prop="bleedRight">
                <el-input placeholder="" v-model="hemorrhageInfo.bleedRight" style="width:200px;">
                  <template slot="prepend">右侧</template>
                  <template slot="append">mm</template>
                </el-input>
              </el-form-item>
            </div>
            <div class="spec-mm">
              <el-form-item label-width="0" label="" style="margin:0;" prop="bleedIn">
                <el-input placeholder="" v-model="hemorrhageInfo.bleedIn" style="width:200px;">
                  <template slot="prepend">内侧</template>
                  <template slot="append">mm</template>
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="addBleed">确定</el-button>
    </div>
  </div>
</template>
<script>
import { bleedDetail, bleedUsable, bleedUpdate, bleedAdd } from '@/api/pms'
export default {
  name: 'add-hemorrhage',
  data () {
    var checkTop = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('未输入上方'))
      } else if (!this.$reg.hemorrhage.reg.test(value) || value < 0) {
        callback(new Error(this.$reg.hemorrhage.message))
      } else {
        callback()
      }
    }
    var checkBottom = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('未输入下方'))
      } else if (!this.$reg.hemorrhage.reg.test(value) || value < 0) {
        callback(new Error(this.$reg.hemorrhage.message))
      } else {
        callback()
      }
    }
    var checkLeft = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('未输入左侧'))
      } else if (!this.$reg.hemorrhage.reg.test(value) || value < 0) {
        callback(new Error(this.$reg.hemorrhage.message))
      } else {
        callback()
      }
    }
    var checkRight = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('未输入右侧'))
      } else if (!this.$reg.hemorrhage.reg.test(value) || value < 0) {
        callback(new Error(this.$reg.hemorrhage.message))
      } else {
        callback()
      }
    }
    var checkInner = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('未输入内侧'))
      } else if (!this.$reg.hemorrhage.reg.test(value) || value < 0) {
        callback(new Error(this.$reg.hemorrhage.message))
      } else {
        callback()
      }
    }
    return {
      isLink: false,
      hemorrhageInfo: {
        bleedBottom: '',
        bleedIn: '',
        bleedLeft: '',
        bleedName: '',
        bleedRight: '',
        bleedTop: ''
      },
      rules: {
        bleedName: [
          { required: true, message: '出血类型', trigger: 'blur' }
        ],
        bleedTop: [
          { validator: checkTop, trigger: 'blur' }
        ],
        bleedBottom: [
          { validator: checkBottom, trigger: 'blur' }
        ],
        bleedLeft: [
          { validator: checkLeft, trigger: 'blur' }
        ],
        bleedRight: [
          { validator: checkRight, trigger: 'blur' }
        ],
        bleedIn: [
          { validator: checkInner, trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    if (this.$route.query.id) {
      this.getEditInfo()
    }
  },
  methods: {
    getEditInfo () {
      bleedDetail(this.$route.query.id).then((res) => {
        if (res.data.success) {
          this.hemorrhageInfo = res.data.data
          // this.hemorrhageInfo.bleedName = res.data.data.bleedName
          // this.hemorrhageInfo.bleedIn = res.data.data.bleedIn
          // this.hemorrhageInfo.bleedOut = res.data.data.bleedOut
          // this.hemorrhageInfo.bleedTop = res.data.data.bleedTop
          // this.hemorrhageInfo.bleedBottom = res.data.data.bleedBottom
        } else {
        }
      })
    },
    // getCompound () {
    //   this.isLink = !this.isLink
    // },
    // bindValue (val) {
    //   if (this.isLink) {
    //     this.hemorrhageInfo.bleedBottom = val
    //     this.hemorrhageInfo.bleedTop = val
    //     this.hemorrhageInfo.bleedIn = val
    //     this.hemorrhageInfo.bleedOut = val
    //   }
    // },
    addBleed () {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let _this = this
          if (this.$route.query.id) {
            bleedUsable({
              act: 1,
              bleedId: this.$route.query.id,
              bleedName: this.hemorrhageInfo.bleedName
            }).then((res) => {
              if (res.data.success) {
                bleedUpdate({ bleedId: _this.$route.query.id, spuBleedVo: _this.hemorrhageInfo }).then((res) => {
                  if (res.data.success) {
                    _this.$message.success('编辑成功')
                    _this.$router.push('./hemorrhage')
                  } else {
                  }
                })
              }
            })
          } else {
            bleedUsable({
              act: 0,
              bleedId: '',
              bleedName: this.hemorrhageInfo.bleedName
            }).then((res) => {
              if (res.data.success) {
                bleedAdd(_this.hemorrhageInfo).then((res) => {
                  if (res.data.success) {
                    _this.$message.success('添加成功')
                    if (_this.$route.path === '/addhemorrhage') {
                      _this.$router.push('./hemorrhage')
                    } else {
                      this.$emit('end', this.hemorrhageInfo.bleedName)
                    }
                  } else {
                    this.$message.warning(res.data.message[0])
                  }
                })
              }
            })
          }
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.add-hemorrhage {
  .spec-mm {
    margin-bottom: 25px;

    span {
      margin-right: 10px;
    }

    .el-input {
      width: 130px;
    }

    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }

  .link {
    width: 30px;
    height: 30px;
    border: 1px solid #dcdfe6;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    box-sizing: border-box;

    i {
      font-size: 20px;
      color: #999;
    }
  }

  .active-link {
    background: #1473e6;
    border: 1px solid #1473e6;

    i {
      color: #fff;
    }
  }
}
</style>
